import {
  cssPropertyToDefaultValueMap,
  generateSkinDefaults,
  REGULAR_STATE,
  withDefaultValues,
} from '@wix/editor-elements-panel';
import type { SiteAssetsSkinParams } from '../TextEffects/TextEffectsShared/TextEffectsShared.skinParams';
import { SkinType as TextParticlesSkinType } from './constants';
import { AnimationType } from './viewer/TextParticles.types';

export const textParticlesSkinParams = {
  font: {
    type: 'FONT',
    state: REGULAR_STATE.id,
    defaultValue: 'font_8',
  },
  'letter-spacing': {
    type: 'SIZE',
    state: REGULAR_STATE.id,
    defaultValue: 'unset',
  },
  minFontSize: {
    type: 'SIZE',
    state: REGULAR_STATE.id,
  },
  maxFontSize: {
    type: 'SIZE',
    state: REGULAR_STATE.id,
  },
  color: {
    type: 'CSS_COLOR',
    defaultValue: '#000000',
    state: REGULAR_STATE.id,
  },
  'text-transform': {
    type: 'TEXT_TRANSFORM',
    state: REGULAR_STATE.id,
    defaultValue: cssPropertyToDefaultValueMap['text-transform'],
  },
  'text-align': {
    type: 'TEXT_ALIGN',
    state: REGULAR_STATE.id,
    defaultValue: 'center',
  },
  // Common animation params
  'effect-type': {
    type: 'CSSString',
    defaultValue: 'reveal',
    state: REGULAR_STATE.id,
  },
  duration: {
    type: 'ALPHA',
    defaultValue: '2',
    state: REGULAR_STATE.id,
  },
  'animation-type': {
    type: 'CSSString',
    defaultValue: AnimationType.IN,
    state: REGULAR_STATE.id,
  },
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'animation-direction': {
    type: 'ALPHA',
    defaultValue: '0',
    state: REGULAR_STATE.id,
  },
  'particle-start-size': {
    type: 'ALPHA',
    defaultValue: '1',
    state: REGULAR_STATE.id,
  },
  'particle-end-size': {
    type: 'ALPHA',
    defaultValue: '1',
    state: REGULAR_STATE.id,
  },
  'particle-start-opacity': {
    type: 'ALPHA',
    defaultValue: '100',
    state: REGULAR_STATE.id,
  },
  'particle-end-opacity': {
    type: 'ALPHA',
    defaultValue: '0',
    state: REGULAR_STATE.id,
  },
  // Effect specific params
  // eslint-disable-next-line editor-elements/no-direction-in-skin-params
  'wind-direction': {
    type: 'ALPHA',
    defaultValue: '0',
    state: REGULAR_STATE.id,
  },
  speed: {
    type: 'ALPHA',
    defaultValue: '1',
    state: REGULAR_STATE.id,
  },
  turbulence: {
    type: 'ALPHA',
    defaultValue: '0.5',
    state: REGULAR_STATE.id,
  },
  'particle-color-count': {
    type: 'ALPHA',
    defaultValue: '1',
    state: REGULAR_STATE.id,
  },
  'text-particles-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
    state: REGULAR_STATE.id,
  },
  'text-particles-color-2': {
    type: 'COLOR',
    defaultValue: '#000000',
    state: REGULAR_STATE.id,
  },
  'text-particles-color-3': {
    type: 'COLOR',
    defaultValue: '#000000',
    state: REGULAR_STATE.id,
  },
  'text-particles-color-4': {
    type: 'COLOR',
    defaultValue: '#000000',
    state: REGULAR_STATE.id,
  },
  noise: {
    type: 'ALPHA',
    state: REGULAR_STATE.id,
    defaultValue: '0',
  },
  amplitude: {
    type: 'ALPHA',
    state: REGULAR_STATE.id,
    defaultValue: '0',
  },
  'start-position': {
    type: 'CSSString',
    state: REGULAR_STATE.id,
    defaultValue: 'random',
  },
  'preset-id': {
    type: 'CSSString',
    state: REGULAR_STATE.id,
    defaultValue: 'reveal-0',
  },
  'particle-duration': {
    type: 'ALPHA',
    state: REGULAR_STATE.id,
    defaultValue: '1',
  },
} as const;

export const skinDefinition = withDefaultValues(textParticlesSkinParams);

export const skinDefinitionMap: Record<string, SiteAssetsSkinParams> = {
  [TextParticlesSkinType]: skinDefinition,
};

export default generateSkinDefaults(skinDefinitionMap);
